import React from "react";
import { useTranslation } from "react-i18next";
import { PDFDownloadLink } from "@react-pdf/renderer";

import { useWindowListener } from "../../helpers/useWindowListener";

import useShowRecaptcha from "../showRecaptcha";
import { useThemeContext } from "../../theme";
import { Steps, useStoreContext } from "../../Store";
import { useRememberMe } from "../../rememberMe";
import useTestJournal from "../TestJournal";

import hero_img from "../../images/hero_img.png";
import { Step01 } from "./steps/step01";
import { Step02 } from "./steps/step02";
import { Step03 } from "./steps/step03";
import { Step03FollowUp } from "./steps/step03FollowUp";
import { Step04 } from "./steps/step04";
import { Step05 } from "./steps/step05";
import { Step06 } from "./steps/step06";
import { Final } from "./steps/stepFinal";

export const isShutdown = () => {
  const eastern = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
  return new Date(eastern) >= new Date(2026, 2, 15); // March 15, 2026 midnight ET
};

const WizardRoutes = {
  [Steps.Step01]: <Step01 />,
  [Steps.Step02]: <Step02 />,
  [Steps.Step03]: <Step03 />,
  [Steps.Step03FollowUp]: <Step03FollowUp />,
  [Steps.Step04]: <Step04 />,
  [Steps.Step05]: <Step05 />,
  [Steps.Step06]: <Step06 />,
  [Steps.Final]: <Final />,
};

const Wizard = () => {
  const { t } = useTranslation();
  const { isEmbedded, isWhiteLabeled } = useThemeContext();
  const { activeStep, setActiveStep } = useStoreContext();
  const { testingHistory } = useRememberMe();
  const { TestJournalContent } = useTestJournal();
  useShowRecaptcha(["Step05", "Step06"].includes(activeStep));

  // Listen to location changes (from the back button) and update the active step
  useWindowListener("hashchange", ({ newURL }) => {
    const nextStep = newURL.split("#")[1];
    setActiveStep(nextStep, null, false);
  });

  if (isShutdown()) {
    return (
      <div className="shutdown-message">
        <img className="hero_img" src={hero_img} alt="" />
        <h1>{t("thank-you")}</h1>
        <p dangerouslySetInnerHTML={{ __html: t("shutdown-message-p1") }}></p>
        <p dangerouslySetInnerHTML={{ __html: t("shutdown-message-p2") }}></p>
        <p dangerouslySetInnerHTML={{ __html: t("shutdown-message-p3") }}></p>
        {testingHistory.length > 0 && (
          <PDFDownloadLink
            className="button test-journal-button"
            fileName="test-results.pdf"
            document={<TestJournalContent />}
          >
            {t("download-journal")}
          </PDFDownloadLink>
        )}
      </div>
    );
  }

  return (
    <div
      className={`step-wizard wizard wizard-step-${activeStep} ${
        isEmbedded ? "embedded" : ""
      } ${isWhiteLabeled ? "white-labeled" : ""}`}
      aria-live="assertive"
    >
      {WizardRoutes[activeStep]}
    </div>
  );
};

export default Wizard;
